// Lightweight, provider-agnostic analytics. No-ops until env IDs are set.
// Pushes to GTM dataLayer and forwards to GA4 (gtag) / Meta Pixel when present.

// page_view and scroll are handled automatically by GA4 Enhanced Measurement,
// so we don't forward them to gtag (avoids duplicate hits). They still go to
// the dataLayer for any GTM tags that want them.
const GA4_SKIP = new Set(["page_view", "scroll_depth"]);

export const track = (event, params = {}) => {
  if (typeof window === "undefined") return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event, ...params });
  if (typeof window.gtag === "function" && !GA4_SKIP.has(event)) {
    window.gtag("event", event, params);
  }
  if (typeof window.fbq === "function") {
    try { window.fbq("trackCustom", event, params); } catch (e) { /* noop */ }
  }
};
